export const NEW_USER = 'new';
export const UNVERIFY_USER = 'unverify';
export const EMAIL_VERIFIED = 'email_verified';
export const VERIFIED = 'verified';



// WEBPACK FOOTER //
// ./app/constants/emailVerifyStatus.js